export default {
  state: {
    userCompanyId: null as null | string,
  },

  setUserCompanyId(id: string) {
    this.state.userCompanyId = id
  },
}
